import { useEffect, useState } from 'react';
import { moduleListApi } from '@services/MedProject';

/**
 * 医项目工作空间侧栏「模块管理」默认指向活动类模块 ID（无则 0）。
 * @param {string | undefined} projectId
 */
export default function useMedProjectActivitiesModuleId(projectId) {
    const [activitiesModuleId, setActivitiesModuleId] = useState(0);

    useEffect(() => {
        if (projectId == null || projectId === '' || projectId === 'new') {
            setActivitiesModuleId(0);
            return;
        }

        let cancelled = false;

        moduleListApi({ projectId }).then(res => {
            if (cancelled) return;

            if (res?.status_code === 200 && Array.isArray(res.data)) {
                const aid = res.data.find(item => item.moduleType === 'activity')?.id;
                setActivitiesModuleId(aid ?? 0);
            } else {
                setActivitiesModuleId(0);
            }
        });

        return () => {
            cancelled = true;
        };
    }, [projectId]);

    return activitiesModuleId;
}
